import CarouselPreview from 'components/messagePreview/components/CarouselPreview';
import SuggestedActionsPreview from 'components/messagePreview/components/SuggestedActionsPreview';
import { RcsMessage, RcsMessageCard } from 'types/rcs';

const LOADING_CARDS: RcsMessageCard[] = [
  {
    buttons: [],
    isVideo: false,
    text: 'Loading...',
    thumbnailUrl: null,
    title: '',
    url: '',
  },
];

interface RcsCarouselPreviewProps {
  cards: RcsMessageCard[];
  carouselOverflowSize?: string;
  isLoading: boolean;
  message: RcsMessage;
  /** If true, the preview will not be interactive */
  inert?: boolean;
}

const RcsCarouselPreview = ({
  cards,
  carouselOverflowSize,
  isLoading,
  message,
  inert,
}: RcsCarouselPreviewProps) => {
  return (
    <>
      <CarouselPreview
        cards={isLoading ? LOADING_CARDS : cards}
        overflowSize={carouselOverflowSize}
      />
      <SuggestedActionsPreview
        suggestedActions={message.suggestedActions}
        inert={inert}
      />
    </>
  );
};

export default RcsCarouselPreview;
